import L from 'leaflet';
import { MapPin, StationType, Todo } from '../schema';
import { Marker } from 'react-leaflet';
import { getStationIconSrc } from '../utils';
import StationMarkerPopup from './StationMarkerPopup';
import { useContext } from 'react';
import { MapContext } from 'src/context';
import { db } from 'src/instant';
import { id } from '@instantdb/core';

interface Props {
    pin: MapPin;
    station: StationType;
    position: L.LatLng;
    isTodo?: boolean;
    todo?: Todo;
    onDelete: () => void;
}

export default function StationMarker(props: Props) {
    const { cleanupMode, currentTodoType, setCurrentTodoType, eventId, toggleTodoMode } = useContext(MapContext);
    const pinId = props.pin.id;
    const cleanupMarker = async () => {
        db.transact(
            db.tx.mapPins[pinId].update({
                cleanedUp: true,
            })
        );
    };
    const iconSrc = getStationIconSrc(props.station);
    const hasNotes = props.pin.notes && props.pin.notes.trim().length > 0;
    const notesIndicator = hasNotes ? '<div class="station-notes-indicator"></div>' : '';

    const leafletIcon =
        props.isTodo && props.todo?.todoType?.color
            ? L.divIcon({
                  className: 'todo-marker-container',
                  html: `
                <div class="todo-marker" style="--todo-color: ${props.todo.todoType.color};">
                    <div class="todo-glow-bg"></div>
                    <img src="${iconSrc}" width="50" height="50" alt="station icon" />
                    ${notesIndicator}
                </div>
            `,
                  iconSize: [50, 50],
                  iconAnchor: [25, 25],
                  popupAnchor: [0, -25],
              })
            : hasNotes
              ? L.divIcon({
                    className: 'station-marker-container',
                    html: `
                <div class="station-marker">
                    <img src="${iconSrc}" width="50" height="50" alt="station icon" />
                    ${notesIndicator}
                </div>
            `,
                    iconSize: [50, 50],
                    iconAnchor: [25, 25],
                    popupAnchor: [0, -25],
                })
              : L.icon({
                    iconUrl: iconSrc,
                    iconSize: [50, 50],
                    iconAnchor: [25, 25],
                    popupAnchor: [0, -25],
                });

    const handleMarkerClick = (_event: L.LeafletMouseEvent) => {
        if (cleanupMode) {
            console.log('cleanup mode');
            cleanupMarker();
            return;
        }

        if (currentTodoType && currentTodoType.interactionType === 'select-existing') {
            const todoId = id();
            const todo = {
                id: todoId,
                completed: false,
                created_at: new Date().toISOString(),
                completed_at: new Date().toISOString(),
                notes: '',
            };

            db.transact(
                db.tx.todos[todoId].update(todo).link({ event: eventId }).link({ todoType: currentTodoType.id }).link({ mapPin: pinId })
            );
            console.log('Created clean bin todo');
            setCurrentTodoType(null);
            toggleTodoMode();
        }
    };

    return (
        <Marker icon={leafletIcon} position={props.position} eventHandlers={{ click: handleMarkerClick }}>
            {!cleanupMode && !currentTodoType && (
                <StationMarkerPopup pin={props.pin} station={props.station} iconSrc={iconSrc} todo={props.todo} onDelete={props.onDelete} />
            )}
        </Marker>
    );
}
